// Customização Takeat Talk: apenas pt_BR e en são carregados.
//
// O Chatwoot original importa os 43 idiomas aqui, e cada um puxa ~45 arquivos
// JSON (~2.500 no total). Em modo dev o Vite serve cada um como uma requisição
// HTTP separada, o que tornava o primeiro carregamento muito lento nesta VPS.
//
// Para reativar um idioma, adicione o import e a chave no export — e habilite
// o mesmo idioma em config/initializers/languages.rb.
import en from './locale/en';
import pt_BR from './locale/pt_BR';

export default {
  en,
  pt_BR,
};
